import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import useFetch from '../hooks/useFetch';
import moment from 'moment';

// Generate Order Data
function createData(id, date, name, description, amount, image) {
  return { id, date, name, description, amount, image };
}

function preventDefault(event) {
  event.preventDefault();
}

export default function Orders() {
  const { data, isLoading } = useFetch('/expenditure');

  console.log(data);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <Typography component='h2' variant='h6' color='primary' gutterBottom>
        Recent Expenditure items
      </Typography>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell align='right'>Invoice Number</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Name of Buyer</TableCell>
            <TableCell>Item Description</TableCell>
            <TableCell align='right'>Amount</TableCell>
            <TableCell align='right'>Vendor</TableCell>
            <TableCell align='right'>Receipt</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.expenditures.map((row) => (
            <TableRow key={row?.id}>
              <TableCell>{row?.invoiceNumber}</TableCell>
              <TableCell>{moment(row?.date).format('YYYY-MM-DD')}</TableCell>
              <TableCell>{row?.name}</TableCell>
              <TableCell>{row?.description}</TableCell>
              <TableCell align='right'>{`$${row?.amount}`}</TableCell>
              <TableCell align='right'>{`${row?.vendorName}`}</TableCell>
              <TableCell align='right'>
                <a href={`${row.photo}`} >
                  View Image
                </a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </React.Fragment>
  );
}
